
const configuracoesGridConfig = {
  idField: "idParametro",
  columns: [
    { header: "Nome", field: "CHAVE" },
    { header: "Descrição", field: "DESCRICAO" },
    { header: "Unidade", field: "UNIDADE" },
    { header: "Valor", field: "VALOR" },
    { header: "Ativo", field: "ATIVO",
      formatter: (value) => (value ? "Sim" : "Não")
    }
  ]
};

export default configuracoesGridConfig;